export { default } from "./HighlightsMobile";
export * from "./HighlightsMobile";
